export default __webpack_public_path__ + "static/media/w1.2f9de3d2.png";